import React, {useEffect, useState} from "react";
import {CustomHeader} from "@pages/new-design-components/custom-components";
import CustomDropdownComponent from "@pages/components/JobDetailsComponents/CustomInspectionDropDown";
import {Input} from "reactstrap";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
export default function DebtRecovery({initialData = {},updateDebt,disabled = false}) {
    const [data,setData] = useState({});
    useEffect(() => {
        if (Object.keys(initialData).length > 0) {
            setData(initialData);
        }
    },[initialData]);
    return (
        <div className={'d-flex flex-wrap g-10'}>
            <div>
                <div>
                    <CustomHeader fontSize={'14px'}  weight={'700'}>
                        Debt Status:
                    </CustomHeader>
                    <CustomHeader fontSize={'14px'}  weight={'700'}>
                        <CustomDropdownComponent
                            withoutDot
                            disabled={disabled}
                            buttonHeight={'100%'}
                            border={'null'}
                            selectedTitle={data?.status}
                            statusArrayKey={'debtRecoveryStatuses'}
                            noBadge={true}
                            handleChange={(value)=>{
                                setData({...data,status:value})
                            }}
                        />
                    </CustomHeader>
                </div>
                <div>
                    <CustomHeader fontSize={'14px'}  weight={'700'}>
                        Decision:
                    </CustomHeader>
                    <CustomHeader fontSize={'14px'}  weight={'700'}>
                        <CustomDropdownComponent
                            withoutDot
                            disabled={disabled}
                            buttonHeight={'100%'}
                            border={'null'}
                            selectedTitle={data?.decision}
                            statusArrayKey={'decisionStatuses'}
                            noBadge={true}
                            handleChange={(value)=>{
                                setData({...data,decision:value})
                            }}
                        />
                    </CustomHeader>
                </div>
            </div>

            <div className={'w-75'}>
                <CustomHeader fontSize={'14px'}  weight={'700'}>
                      Note:
                </CustomHeader>
                <Input
                    className="form-control-alternative edit-event--title"
                    placeholder="Note"
                    type="textarea"
                    disabled={disabled}
                    rows="8"
                    value={data.note} onChange={(e) => setData({...data,note:e.target.value})}
                />

            </div>

                   <div className={'d-flex'}>
                       <ButtonContainer disabled={JSON.stringify(data) == JSON.stringify(initialData)}  onClick={() => setData(initialData)}>Clear</ButtonContainer>
                       <ButtonContainer  disabled={JSON.stringify(data) == JSON.stringify(initialData)} onClick={() => updateDebt(data)}>Save</ButtonContainer>
                   </div>

        </div>
    )
}